export default __webpack_public_path__ + "static/media/LogoutWhite.01de2d5b.svg";